import { capitalize } from '@utils/textHelper';

export const getFullName = (firstName, lastName) =>
  `${capitalize(firstName)} ${capitalize(lastName)}`;

export const getUserModel = (user = {}) => ({
  ...user,
  description: user.bio || null,
  thumbnail: user.avatarV1 || user.avatar || null,
  liveMinutes: user.liveMinutes ? Math.round(user.liveMinutes / 60) : 0,
  totalWatchMins: user.totalWatchTime
    ? Math.round(user.totalWatchTime / 60)
    : 0,
  name: getFullName(user.firstName, user.lastName),
  newEducatorAvatar: user.avatarV1Web || null,
  oldAvatar: user.oldAvatar || null,
  fallbackAvatar: user.avatar || null
});
